import React from "react";
import style from "../ritualpraxis.module.css";
import { Button } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

function FtrPrevNxtBtnComponent( { allComponentViewerState, onNext, onPrevious, currentIndex, totalChapters, buttonText }) {
  return (
    <>
      <div className={style.centraldoctraine_and_other_commonfooterblock}>
        <div
          className={
            style.centraldoctraine_and_other_commonfooterblock_commonwidth
          }
        >
          <div className={style.ftr_NextAndPrevious_btn}>
                    {!allComponentViewerState && currentIndex > 0 && (
                        <Button className={style.previousbtn_css} onClick={onPrevious}>
                            <KeyboardArrowLeftIcon className={style.black_btn_icon} />
                            <span>previous {buttonText}</span>
                        </Button>
                    )}

                    {!allComponentViewerState && currentIndex < totalChapters - 1 && (
                        <Button className={style.nextbtn_css} onClick={onNext}>
                            <span>NEXT <br /> {buttonText}</span>
                            <ChevronRightIcon className={style.black_btn_icon} />
                        </Button>
                    )}
                </div>
          <div
            className={
              style.centraldoctraine_and_other_commonfooterblock_mainwrapper
            }
          >
            <div
              className={
                style.centraldoctraine_and_other_commonfooterblock_innerwrapper
              }
            >
              <p
                className={
                  style.centraldoctraine_and_other_commonfooterblock_title
                }
              >
                "Become a professional <span>divination consultant,</span>
              </p>
              <p
                className={
                  style.centraldoctraine_and_other_commonfooterblock_subtitle
                }
              >
                <span>click here</span> to see our 24 week courses!"
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FtrPrevNxtBtnComponent;
